import { useMutation } from '@apollo/client';
import ActivateMutation from './ActivateMutation';

const ActivateConnectorApollo = ({ children }) => {
  const [mutate] = useMutation(ActivateMutation);

  const createActivate = async (request) => {
    const variables = request;
    const response = await mutate({
      variables,
    });

    return response;
  };

  return children({
    activateAccount: createActivate,
  });
};

export default ActivateConnectorApollo;
